import React, { useEffect, useState } from "react";
import $ from "jquery";
import axios from "axios"; 
import FormValidator from "../../../inc/FormValidator";
import Api from "../../../inc/Api";
import Settings from "../../../inc/Settings";
import Button from "../../inc/Button";
import Collapse from "../../inc/Collapse"; 
import FieldsRenderer from "../../Purchase Orders Internal/Edit PO/FieldsRenderer";
import Helper from "../../../inc/Helper";
import { Form } from "react-bootstrap";
import { getPopupMessageBasedOnStatus } from "../../../inc/Validation";
import Popup from "../../Popup/Popup";
import CommonAPICalls from "../Common Integration Calls/CommonApiCalls";

let cancelTokenSource = axios.CancelToken.source();
const OperationMappingFormsPopup = ({ setClosePopupViewModal, reloadParentGrid }) => {
  const [popupFormData, setPopupFormData] = useState({});

  const [apiMaster, setApiMaster] = useState([]);
  const [sources, setSources] = useState([]);
 
  const [apiCallBtn, setApiCallBtn] = useState(false);

  useEffect(() => {  
    fetchDataForSystemDetails();
  }, [])

  let popupFormValidator;

  const validationConfigure = () => {
    let popupFieldConfig = [
      { name: "operation_name", displayName: "Name", types: ["Required"] },
      { name: "parameters", displayName: "Parameters", types: ["Required"] },
      { name: "response_type", displayName: "Response type", types: ["Required"] }, 
      { name: "api", displayName: "Api", types: ["Required"] },
      { name: "source", displayName: "Source", types: ["Required"] } 
    ];

    if (!popupFormValidator) {
      popupFormValidator = new FormValidator(popupFieldConfig);
    }
  };

  validationConfigure();
 
  const fetchDataForSystemDetails = async () => {
    const apiCalls = new CommonAPICalls();
    try {
      const systemApiMasterResponse = await apiCalls.getSystemApiDetails();
      const systemSourcesResponse = await apiCalls.getSystemSourceMaster();

      if (systemApiMasterResponse) {
        setApiMaster(systemApiMasterResponse);
      };
      if(systemSourcesResponse) {
        setSources(systemSourcesResponse);
      };
    } catch (error) { 
      setApiMaster([]); 
      setSources([]);
    }
  }
 
  const fieldsArrayGeneral = [
    {
      className: "col-lg-4",
      label: "Operation name",
      required: true,
      inputType: "text",
      id: "operation_name",
      name: "operation_name"
    },
    {
      className: "col-lg-4",
      label: "Parameters",
      required: true,
      inputType: "text",
      id: "parameters",
      name: "parameters"
    },
    {
      className: "col-lg-4",
      label: "Response type",
      required: true, 
      inputType: "text",
      id: "response_type",
      name: "response_type"
    }, 
    {
      className: "col-lg-4",
      label: "is Active",
      inputType: "checkbox",
      id: "is_active",
      name: "is_active"
    },
    {
      className: "col-lg-4",
      label: "Api",
      inputType: "dropdown",
      options: apiMaster,
      required: true, 
      id: "api",
      name: "api"
    }, 
    {
      className: "col-lg-4",
      label: "Source",
      inputType: "dropdown",
      options: sources,
      required: true, 
      id: "source",
      name: "source"
    }
  ];

  const onClosePopupClick = () => {
    $("html").removeClass("rs_popup_open");
    setClosePopupViewModal(false);
  };

  const executePOSTPopupDocumentAPI = async () => {
    try { 
      let api = Api;
      api.setUserToken();

      const res = await api
        .axios()
        .post(
          Settings.apiAppUrl + "/operation-mapping/",
          {
            ...popupFormData,
            is_active: popupFormData.is_active == 'on'
          },
          { cancelToken: cancelTokenSource.token }
        );

      if (res?.data?.success) {
        Helper.alert(res?.data?.message || 'Operation mapping created successfully', 'success');
        reloadParentGrid();
        onClosePopupClick(); 
      } else {
        Helper.alert(res?.data?.message, 'error')
      }
    } catch (error) {  
      getPopupMessageBasedOnStatus(error);
    }
  };

  const handleSubmit = () => {
    if (!popupFormValidator.isValid({ ...popupFormData })) {
      popupFormValidator.displayMessage();
      popupFormValidator.reset();
      return;
    }

    Helper.createDebouncedAPIFunction(
      [executePOSTPopupDocumentAPI],
      setApiCallBtn,
      cancelTokenSource
    )();
  };
  return (
    <Popup
      autoOpen={true}
      width="900px"
      onClose={onClosePopupClick}
    > 
      <>
        <h5 className="create_rfq_modal__title">Create Operation Mapping</h5>

        <Collapse
          className="mt-4 mb-4"
          open={true}
          title={"General Information"}
        >
          <Form>
            <div className="container-fluid">
              <FieldsRenderer
                updateState={setPopupFormData}
                currentState={popupFormData}
                fieldsArray={fieldsArrayGeneral}
              />
            </div>
          </Form>
        </Collapse>
      </> 

      <div
        className="addDocumentNumber-body-buttons"
        style={{ justifyContent: "flex-end" }}
      >
        <Button
          isActive={false}
          title={"Cancel"}
          onClick={onClosePopupClick}
        />
        <Button
          isDisable={apiCallBtn}
          className="solid_btn"
          isActive={true}
          title={<div><span> {"Create"} </span> {apiCallBtn ? <output className="spinner-border spinner-border-sm ms-1" aria-hidden="true"></output> : ''}</div>}
          onClick={handleSubmit}
        />
      </div>
    </Popup>
  );
};

export default OperationMappingFormsPopup;